import { useFilterContext } from '../Filter.context';
import { getOptionLabel } from '../Filter.utils';
import Icon from '../../Icon/Icon';
import FilterSwitch from '../FilterSwitch/FilterSwitch';
import FilterSwitchGroup from '../FilterSwitch/FilterSwitchGroup';

type FilterSwitchAdapterProps = {
  category: string;
};

const FilterSwitchAdapter = (props: FilterSwitchAdapterProps) => {
  const { category } = props;
  const { data, onFilterChange, state } = useFilterContext();
  const { iconsMap, options, optionsMap } = data[category];

  if (!options?.length) {
    return null;
  }

  const value = state[category]?.[0] || '';

  return (
    <FilterSwitchGroup onChange={(newValue) => onFilterChange(category, [newValue])} value={value}>
      {options.map((opt) => (
        <FilterSwitch key={opt} value={opt}>
          {iconsMap && iconsMap[opt] && <Icon color="icon/tertiary" name={iconsMap[opt]} size="16" />}
          {getOptionLabel(opt, optionsMap)}
        </FilterSwitch>
      ))}
    </FilterSwitchGroup>
  );
};

export default FilterSwitchAdapter;
